import PropTypes from "prop-types";
import React from "react";
import "./htmlText.css";

// ----------------------------------------------------------------------------

export default function HtmlText(props) {
  const { text, lineHeight } = props;

  return (
    <div
      className="htmlText"
      style={{ lineHeight: 1.6 }}
      dangerouslySetInnerHTML={{ __html: text }}
    ></div>
  );
}

// -------------------------------------
// Component PropTypes and default props
// -------------------------------------

HtmlText.propTypes = {
  style: PropTypes.any,

  title: PropTypes.string,
  showSearchBar: PropTypes.bool,
  onBack: PropTypes.func,
  searchValue: PropTypes.string,
  onSearch: PropTypes.func,
  onCart: PropTypes.func,
  onPressSearch: PropTypes.func,
  renderExtraRow: PropTypes.func,
};
HtmlText.defaultProps = { style: {} };

// ----------------------------------------------------------------------------
